var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.4 36.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1013 -171)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1031.2,
    cy: 189.2,
    r: 18.2,
    fill: "#c7d0d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.2 192.5c-.3 0-.6-.1-.8-.3-2.1-2.1-2.1-5.5 0-7.6l4.2-4.2c2.1-2.1 5.5-2.1 7.6 0 2.1 2.1 2.1 5.5 0 7.6l-1.9 1.9c-.4.4-1.2.4-1.6 0-.4-.4-.4-1.2 0-1.6l1.9-1.9c1.2-1.2 1.2-3.2 0-4.3-1.2-1.2-3.1-1.2-4.3 0l-4.2 4.2c-1.2 1.2-1.2 3.1 0 4.3.4.4.4 1.2 0 1.6-.3.2-.6.3-.9.3zm-4 8.3c-3 0-5.4-2.4-5.4-5.4 0-1.4.6-2.8 1.6-3.8l1.9-1.9c.4-.5 1.2-.5 1.6-.1.5.4.5 1.2.1 1.6l-.1.1-1.9 1.9c-1.2 1.2-1.2 3.2 0 4.3 1.2 1.2 3.1 1.2 4.3 0l4.2-4.2c1.2-1.2 1.2-3.1 0-4.3-.5-.4-.5-1.2 0-1.6.4-.5 1.2-.5 1.6 0 2.1 2.1 2.1 5.5 0 7.6l-4.2 4.2c-1 1-2.3 1.6-3.7 1.6z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/iconCopy.1c86c6ed.svg";
export { ForwardRef as ReactComponent };